module.exports = require('./dist/src/components/radio-button');
